<template>
<div>
    <template v-if="!flag">
        <template v-if="!haveStyle">
          <span style="color: #fff;" >{{time}}</span><span class="fix-time">后失效</span>
        </template>
       <div class="shopping-time-con" v-else>
           <span class="shopping-time">{{h}}</span>
            <span class="shopping-time-divide">:</span>
            <span class="shopping-time">{{m}}</span>
            <span class="shopping-time-divide">:</span>
            <span class="shopping-time">{{s}}</span>
            <span class="shopping-time-divide">:</span>
            <span class="shopping-time">{{ms}}</span>
            <span class="shopping-time-span">后失效</span>
     </div>
    </template>
    <template v-else>
      <template v-if="!haveStyle">
          <span style="color: #fff;" >00:00:00:00</span><span class="fix-time">后失效</span>
        </template>
       <div class="shopping-time-con" v-else>
         <span class="shopping-time">00</span>
            <span class="shopping-time-divide">:</span>
            <span class="shopping-time">00</span>
            <span class="shopping-time-divide">:</span>
            <span class="shopping-time">00</span>
            <span class="shopping-time-divide">:</span>
            <span class="shopping-time">00</span>
            <span class="shopping-time-span">后失效</span>
        </div>
    </template>
</div>
 
</template>

<script>
export default {
    name: 'timeCountDown',
    props:{
        endTime : {
        type :[String, Number] 
      },
      haveStyle:{
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        time : '',
        h:"",
        m:"",
        s:"",
        ms:"",
        flag : false,
        
      }
    },
     mounted () {
      let time = setInterval(()=>{
        if(this.flag == true){
          this.$emit('timeOverHandle')
          clearInterval(time)
        }
        this.timeDown()
      },100)
    },
    methods:{
       timeDown () {
        // const endTime = new Date(this.endTime)
        const endTime = +this.endTime
        const nowTime = new Date();
        // let leftTime = parseInt((endTime.getTime()-nowTime.getTime())/1000)
        // let leftTime = parseInt((endTime-nowTime.getTime())/1000)
        // let d = parseInt(leftTime/(24*60*60))
        // let h = this.formate(parseInt(leftTime/(60*60)%24))
        // let m = this.formate(parseInt(leftTime/60%60))
        // let s = this.formate(parseInt(leftTime%60))
         let leftTime = parseInt(endTime-nowTime.getTime())
        let d = parseInt(leftTime/(24*60*60*1000))
        let h = this.formate(parseInt(leftTime/(60*60*1000)%24))
        let m = this.formate(parseInt(leftTime/(60*1000)%60))
        let s = this.formate(parseInt(leftTime/1000%60))
        let ms = this.formate(parseInt((leftTime%1000)/100))
        if(leftTime <= 0){
          this.flag = true
          this.$emit('time-end')
        }
        this.time = `${h}:${m}:${s}:${ms}`
        this.h=h
        this.m=m
        this.s=s
        this.ms=ms
        // this.time = `${h}:${m}:${s}`
      },
      formate (time) {
        if(time>=10){
          return time
        }else{
          return `0${time}`
        }
      }
    }
}
</script>

<style lang="less" scoped>
.fix-time{
    font-size: 0.26rem;
    margin-left: 0.08rem;
}
.shopping-time-con {
        // padding-top: 0.6rem;
        // display: flex;
        font-size: 0.24rem;
        .shopping-time {
          border: 0.02rem solid rgb(255, 255, 255, 0.8);
          border-radius: 0.04rem;
          font-size: 0.24rem;
          line-height: 0.4rem;
          padding: 0 0.04rem;
        }
        .shopping-time-divide {
          margin: 0 0.02rem;
        }
        .shopping-time-span {
          font-size: 0.26rem;
          margin-left: 0.09rem;
        }
      }
</style>